import { useNavigate } from "react-router-dom";
import { useApp } from "@/lib/store";
import { media } from "@/lib/api";
import { X, Minus, Plus, Trash2, ArrowRight, ShoppingCart } from "lucide-react";

export default function VRCart({ onClose, track }) {
  const { cart, updateQty, removeFromCart } = useApp();
  const navigate = useNavigate();
  const subtotal = cart.reduce((a, c) => a + (c.variant.price || 0) * c.qty, 0);

  return (
    <div className="fixed inset-0 z-[85] flex justify-end" data-testid="vr-cart-panel">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-md h-full bg-[#080c12] border-l border-cyan-400/20 flex flex-col">
        <div className="p-4 border-b border-white/10 flex items-center gap-2">
          <ShoppingCart size={18} className="text-cyan-300" />
          <div className="font-semibold text-white flex-1">Lab Cart</div>
          <button onClick={onClose} className="p-2 text-slate-400 hover:text-white"><X size={18} /></button>
        </div>
        <div className="flex-1 overflow-y-auto p-4 space-y-3">
          {cart.length === 0 && <div className="text-slate-500 text-sm font-mono text-center mt-10">Your lab cart is empty.</div>}
          {cart.map((c) => (
            <div key={c.variant.id} className="flex gap-3 items-center rounded-2xl border border-white/10 p-3" data-testid={`vr-cart-item-${c.variant.sku}`}>
              <div className="w-14 h-14 rounded-lg bg-black/40 overflow-hidden shrink-0">
                {c.product.image && <img src={media(c.product.image)} alt="" className="w-full h-full object-cover" />}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm text-white truncate">{c.product.name}</div>
                <div className="text-[11px] text-slate-400 font-mono">{c.variant.label} · ${(c.variant.price || 0).toFixed(2)}</div>
                <div className="flex items-center gap-2 mt-1">
                  <button className="p-1 text-slate-300" onClick={() => updateQty(c.variant.id, c.qty - 1)}><Minus size={12} /></button>
                  <span className="text-xs font-mono w-6 text-center">{c.qty}</span>
                  <button className="p-1 text-slate-300" onClick={() => updateQty(c.variant.id, c.qty + 1)}><Plus size={12} /></button>
                  <button className="p-1 text-rose-400 ml-auto" onClick={() => removeFromCart(c.variant.id)}><Trash2 size={13} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="p-4 border-t border-white/10">
          <div className="flex justify-between text-sm text-slate-300 mb-3"><span>Subtotal</span><span className="font-mono text-white">${subtotal.toFixed(2)}</span></div>
          <button disabled={cart.length === 0} data-testid="vr-cart-checkout"
            onClick={() => { track && track("checkout_start"); navigate("/checkout"); }}
            className="w-full bg-cyan-400 text-black font-semibold rounded-xl py-3 flex items-center justify-center gap-2 disabled:opacity-40">
            Proceed to Checkout <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
